import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
export var getPreferenceUI = function getPreferenceUI(preferedUIvalue, hasSeenNewExperiencePopup, physicianId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _a, prefsUrl, tokenForPrefs, payload, prefsResp, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            prefsUrl = ((_a = window.appConfig) === null || _a === void 0 ? void 0 : _a.preferencesUrl) || "".concat(window.appConfig.v2ApiUrl, "/api/v1/physicians/").concat(physicianId, "/preferences/ui");
            tokenForPrefs = sessionStorage.getItem("authToken");
            payload = {
              prefersLegacyUi: preferedUIvalue,
              hasSeenNewExperiencePopup: hasSeenNewExperiencePopup
            };
            _context.next = 5;
            return fetch(prefsUrl, {
              method: "POST",
              headers: Object.assign({
                "Content-Type": "application/json"
              }, tokenForPrefs ? {
                Authorization: "Bearer ".concat(tokenForPrefs)
              } : {}),
              body: JSON.stringify(payload)
            });
          case 5:
            prefsResp = _context.sent;
            _context.next = 8;
            return prefsResp.json();
          case 8:
            data = _context.sent;
            return _context.abrupt("return", data);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
export var getV2OrderIdBySampleId = function getV2OrderIdBySampleId(id, isEnRoute) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var baseUrl, apiUrl, token, response, data, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            baseUrl = window.appConfig.v2ApiUrl;
            if (baseUrl) {
              _context2.next = 3;
              break;
            }
            throw new Error("v2ApiUrl is not configured");
          case 3:
            apiUrl = isEnRoute ? "".concat(baseUrl, "/api/v1/orders/by-temp-sample/").concat(id) : "".concat(baseUrl, "/api/v1/orders/by-sample/").concat(id);
            token = sessionStorage.getItem("authToken");
            if (token) {
              _context2.next = 7;
              break;
            }
            throw new Error("No auth token available for V2 request");
          case 7:
            _context2.next = 9;
            return fetch(apiUrl, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer ".concat(token)
              }
            });
          case 9:
            response = _context2.sent;
            if (response.ok) {
              _context2.next = 12;
              break;
            }
            throw new Error("Failed to get V2 order ID: ".concat(response.status));
          case 12:
            _context2.next = 14;
            return response.json();
          case 14:
            data = _context2.sent;
            result = data.data;
            if (!(!(result === null || result === void 0 ? void 0 : result.orderId) || (result === null || result === void 0 ? void 0 : result.patientId) == null)) {
              _context2.next = 18;
              break;
            }
            throw new Error("Invalid response shape from V2 order lookup");
          case 18:
            return _context2.abrupt("return", result);
          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
export default {
  getPreferenceUI: getPreferenceUI
};